import { defineStore } from 'pinia'

interface AppState {
  times: number
  activeNum: number
  name: string
  locale: string
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    times: 5,
    name: '',
    activeNum: 0,
    locale: 'zh-CN'
  }),

  actions: {
    increment() {
      this.times++
    },
    clearName() {
      this.name = ''
    },
    setActive(num: number) {
      this.activeNum = num
    },
    setLocale(locale: string) {
      this.locale = locale
    }
  },

  persist: import.meta.client && {
    storage: localStorage,
    paths: ['times', 'name', 'activeNum', 'locale']
  }
})
